/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { ALIGN, ILanding, ILandingSection, OVERFLOW_TYPE } from "../../../data/interfaces"
import Delimiter from "../delimiter"
import Background from "./Background"
import Container from "./Container"
import DataComponents from "./DataComponents"
import Description from "./Description"
import Floats from "./floats/Floats"
import Title from "./Title"
import TitleContainer from "./TitleContainer"
import Waypoint from "./Waypoint"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import ProportiaHandler from "../landing-edit/ProportiaHandler"

/* Protopia Ecosystem component */  
export interface ISectionProps {
    section: ILandingSection
    i: number
    children?: JSX.Element 
    containerChildren?: JSX.Element 
}
const Section = ({...props}: ISectionProps): JSX.Element => { 
    const [section, setSection] = useState<ILandingSection>(props.section) 
    const {position} = usePosition( section )  
    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find(s => s.id === props.section.id)!
                // console.log( "Section current:", sec )
                // console.log( "Section previous:", section ) 
                // console.log( "Section-props:", props.section ) 
                // console.log( "Section-3:", JSON.stringify( sec ) !== JSON.stringify( section ) )
                // if( JSON.stringify( sec ) !== JSON.stringify( section ) ) {
                    setSection(( prevState ) => { 
                        // console.log( "prev state: ",prevState ) 
                        return sec
                    })
                // }
            }, 
            {} 
        ) 
        return () => {
            unsubscribe();
        };
    }, [])  
       
    
    const { layoutHeight }  = useScreenSize( )
    const getHeight = () => {
        return getCssDemention(
            !!position.height && position.height !== "100%"
                ?
                position.height
                :
                section.height === "100%" ||  section.height === "100dvh"  ||  section.height === "100vh" 
                    ?
                    layoutHeight
                    :
                    section.height, 
                "auto"
        ) 
    }
    useEffect(() => {
        const verticalAlign     = setVerticalAlignToCSSRule(  section.vertical_align ||ALIGN.MIDDLE ) 
        const horizontalAlign   = setHorizontalAlignToCSSRule(  section.horizontal_align ||ALIGN.FULL ) 
        const paddingTop        = getCssDemention( section.paddingTop, "75px" ) 
        const paddingBottom     = getCssDemention( section.paddingBottom, "75px" ) 
       
        addCSSClass(
            `section-${ section.id }`,
            `.section-${ section.id } {
                min-height: ${ getHeight() };
                overflow: ${section.overflow || OVERFLOW_TYPE.HIDDEN};
                ${verticalAlign}
                ${horizontalAlign}
                padding-top: ${paddingTop};
                padding-bottom: ${paddingBottom};
                z-index: ${position.z || props.i};
            }`
        )
    }, [ position, section ])
    
    return <>
        <section role="article" className={`section-${ section.id } landing-section `}> 
            <Background section={ section } />            
            <Container section={ section } i={ props.i }>
                <TitleContainer section={ section } > 
                    <Title  section={ section } /> 
                    <Description  section={ section } /> 
                </TitleContainer>
                <DataComponents section={section} data={section.data} />                    
                <Floats floats={ section.floats } section={ section } /> 
                <>{ props.containerChildren }</>
            </Container> 
            <Waypoint section={ section } />
            <Delimiter section={section}/>
            { props.children }
        </section>
    </>
}
export default memo(Section)

export const setVerticalAlignToCSSRule = (align:ALIGN): string => {
    switch(align) {
        case ALIGN.START:
            return `justify-content: flex-start;`
        case ALIGN.END:
            return `justify-content: flex-end;`
        case ALIGN.FULL:
            return `justify-content: space-between;`
        case ALIGN.MIDDLE:
        default:
            return `justify-content: center;`
    }
}

export const setHorizontalAlignToCSSRule = (align:ALIGN): string => {
    switch(align) {
        case ALIGN.START:
            return `align-items: flex-start;`
        case ALIGN.END:
            return `align-items: flex-end;`
        case ALIGN.FULL:
            return `align-items: stretch;`
        case ALIGN.MIDDLE:
        default:
            return `align-items: center;`
    }
}